import { RadioGroupProps, fieldToRadioGroup } from 'formik-material-ui';
// eslint-disable-next-line
import React, { useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import { useEventListener } from 'utils/hooks';
import { isRequiredField } from './helpers';
import useStyles from './CustomRadioGroup.style';

type Props = {
  label: string;
  name: string;
} & RadioGroupProps;

const CustomRadioGroup: React.FC<Props> = ({
  children,
  field,
  form,
  ...rest
}) => {
  const formik = useFormikContext();
  const required: boolean = !!rest.label && isRequiredField(formik, field.name);
  const error: boolean = getIn(form.errors, field.name);
  const errorNotice: boolean = getIn(form.touched, field.name) && !!error;
  const classes = useStyles();
  const { setFieldValue } = form;

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      const target = event.target as HTMLInputElement;
      if (!target) return;
      if (event.which === 13 || event.keyCode === 13) {
        setFieldValue(target.name, target.value);
      }
    },
    [setFieldValue]
  );

  useEventListener('keydown', handleKeyPress);

  return (
    <FormControl margin="dense" className={classes.formControlCustom}>
      <FormLabel
        required={required}
        error={errorNotice}
        className={classes.formLabel}
      >
        {rest.label}
      </FormLabel>

      <RadioGroup
        aria-label={rest.label}
        className={classes.formControlGroup}
        {...fieldToRadioGroup({ field, form, ...rest })}
      >
        <Grid className={classes.radioGroup}>{children}</Grid>
      </RadioGroup>

      {errorNotice && (
        <FormHelperText error className={classes.formControlErrors}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomRadioGroup;
